import React, { useCallback, useMemo } from 'react';

import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import PrintDocumentMenuItem from '../../../../../../../components/print-document-menu-item';
import { SHIPMENT } from '../../../../../../../constants/fulfillment-types';
import { useLabelDefaultPrintSettings } from '../../../../../../../containers/print-document-button-containers/order-details/hooks/use-label-default-print-settings';
import { emptyObject } from 'ui-components/default-props/empty';
import { useEntitiesFulfillment } from '../../../../../../../hooks/entities/selectors/fulfillments';
import Global from '../../../../../../../store/global-selectors';
import { printLabel } from '../../../../../../../store/printing/print.actions';
import {
  ORDER_DETAILS_ACTIONS,
  useTrackOrderDetailsAction,
} from '../../../../../../modals/order-details-modal/event-tracking/use-track-order-details-action';
import messages from '../../../../../rate-card/read-only/label-actions/messages';

const isPrintLabelDisabled = (doesUserHaveShippingRole, isLabelVoided, fulfillmentType) => {
  if (!doesUserHaveShippingRole) {
    return true;
  }

  if (isLabelVoided) {
    return true;
  }

  return fulfillmentType?.toLowerCase?.() !== SHIPMENT.toLowerCase();
};

const PrintLabelMenuItem = ({ fulfillmentId }) => {
  const { fulfillmentPlanId, isLabelVoided, fulfillmentType, labelPrintedStatus } = useEntitiesFulfillment(fulfillmentId) || emptyObject;

  const trackLabelClicks = useTrackOrderDetailsAction(ORDER_DETAILS_ACTIONS.PRINT_LABELS);
  const userHasShippingRole = useSelector(Global.selectUserhasShippingRole);
  const dispatch = useDispatch();

  const hasPrintedLabel = labelPrintedStatus?.isPrinted;

  const isDisabled = useMemo(
    () => isPrintLabelDisabled(userHasShippingRole, isLabelVoided, fulfillmentType),
    [fulfillmentType, isLabelVoided, userHasShippingRole],
  );

  const fulfillmentIds = useMemo(() => {
    return [fulfillmentId];
  }, [fulfillmentId]);

  const onClick = useCallback(() => {
    dispatch(printLabel([fulfillmentPlanId], fulfillmentIds, hasPrintedLabel, false, false));
    trackLabelClicks();
  }, [dispatch, fulfillmentIds, fulfillmentPlanId, hasPrintedLabel, trackLabelClicks]);

  const defaultPrintSetting = useLabelDefaultPrintSettings(fulfillmentIds, hasPrintedLabel);

  return (
    <PrintDocumentMenuItem defaultPrintSetting={defaultPrintSetting} disabled={isDisabled} name={messages.printLabel} onClick={onClick} />
  );
};

export { PrintLabelMenuItem };

PrintLabelMenuItem.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};
